import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../../../../components/ui/dialog";
import { WeldDataTable } from './WeldDataTable';
import type { WeldData } from './WeldDataTable';

interface WeldDataModalProps {
  isOpen: boolean;
  onClose: () => void;
  assemblyNumber: string;
  welds: WeldData[];
}

export const WeldDataModal: React.FC<WeldDataModalProps> = ({
  isOpen,
  onClose,
  assemblyNumber,
  welds
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[100vw] w-screen h-screen max-h-screen p-0 gap-0">
        <div className="flex flex-col h-full">
          <DialogHeader className="px-6 py-4 border-b">
            <div className="flex items-center">
              <DialogTitle className="text-2xl font-bold">
                Weld Data - {assemblyNumber}
              </DialogTitle>
            </div>
          </DialogHeader>
          <div className="flex-1 overflow-auto p-6">
            <WeldDataTable assemblyNumber={assemblyNumber} welds={welds} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}; 